import React from "react"
import '../component/Navbar.css';
import {Link} from 'react-scroll';

function Navbar(){
    return (
        <>
        <header class="header">
        <a href="#" class="logo">Code it's Fun</a>
        <i class="fa-solid fa-bars" id="menu-icon"></i>
        <nav class="navbar" >
            <Link to="home" spy={true} smooth={true} offset={-100} duration={500} id="home1" href="#" class="active">Home</Link>
            <Link to="services" spy={true} smooth={true} offset={-100} duration={500} id="Services1" href="#">Services</Link>
            <Link to="skills" spy={true} smooth={true} offset={-100} duration={500} id="Skills1" href="#">Skills</Link>
            <Link to="contect" spy={true} smooth={true} offset={-100} duration={500} id="contect1" href="#">Contect</Link>

        </nav>  
    </header>
        </>
    )
}
export default Navbar